import script from "./ESportsUpcoming.vue?vue&type=script&setup=true&lang=js"
export * from "./ESportsUpcoming.vue?vue&type=script&setup=true&lang=js"

import "./ESportsUpcoming.vue?vue&type=style&index=0&id=3a7e57eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a7e57eb"]])

export default __exports__